(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('confirm-account-deletion', {
            parent: 'account',
            data: {
                authorities: ['open']
            },
            url: '/delete-account/confirm?key',
            views: {
                'content@': {
                    templateUrl: 'app/account/confirm-account-deletion/confirm-account-deletion.html',
                    controller: 'AccountDeletionConfirmationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('delete-account');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
